import { render, staticRenderFns } from "./DialogContactComponent.vue?vue&type=template&id=215c1824&"
import script from "./DialogContactComponent.vue?vue&type=script&lang=js&"
export * from "./DialogContactComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogContactComponent.vue?vue&type=style&index=0&id=215c1824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports